export type ProductKey =
  | "autoSpecs"
  | "build"
  | "cost"
  | "designCollaboration"
  | "docs"
  | "insight"
  | "modelCoordination"
  | "projectAdministration"
  | "takeoff"
  | "assets"
  | "costManagement"
  | "designCollaboration"
  | "documentManagement"
  | "field"
  | "fieldManagement"
  | "glue"
  | "insight"
  | "plan"
  | "projectHome"
  | "projectManagement"
  | "quantification"
  | "unkown";

export type AccessLevel = "administrator" | "member" | "none";

export class ACCProjectProduct {
    key: ProductKey = "unkown";
    access: AccessLevel = "none";

    public static fromAutodeskJSON(json: any): ACCProjectProduct
    {
        let product = new ACCProjectProduct();
        product.key = json.key;
        product.access = json.access;
        return product;
    }
};
  